import { Popup, PopupProps } from "lib/classes/popup";
import { getLocaleString } from "lib/localization/vendor";

import parse from "html-react-parser";

const HelpMapLayersPopup = new Popup({
	title: () => getLocaleString("tctitle"),
	style: {maxWidth: 600},
	distinct: true,
	render: () => {
		return (
			<>
				{parse(getLocaleString("t&c"))}
			</>
		)
	}
});

export default HelpMapLayersPopup;